"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyFromRequest = keyFromRequest;
const stentor_guards_1 = require("stentor-guards");
/**
 * From the provided request it pulls out the event that is used
 * to then get the content, forwards, and logic.
 *
 * @param {Request} request
 * @returns {string}
 */
function keyFromRequest(request) {
    let key;
    if (!request) {
        return undefined;
    }
    if ((0, stentor_guards_1.isIntentRequest)(request) ||
        (0, stentor_guards_1.isLaunchRequest)(request) ||
        (0, stentor_guards_1.isInputUnknownRequest)(request) ||
        (0, stentor_guards_1.isOptionSelectRequest)(request) ||
        (0, stentor_guards_1.isPermissionRequest)(request) ||
        (0, stentor_guards_1.isSignInRequest)(request)) {
        key = request.intentId;
    }
    if (request.overrideKey) {
        key = request.overrideKey;
    }
    return key;
}
//# sourceMappingURL=keyFromRequest.js.map